import axios from "axios";
import { isPublicAdminPath } from "./components/RequireAuth";
import API from "./constant/api";

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  const requestUrl = String(config.url || "");
  const apiBase = String(API.PORTNUMBER || "").replace(/\/$/, "");
  const isApiRequest = requestUrl.startsWith("/") || requestUrl.startsWith(apiBase);

  if (token && isApiRequest) {
    config.headers = config.headers || {};
    if (!config.headers["x-access-token"]) {
      config.headers["x-access-token"] = token;
    }
  }

  return config;
});

// Every component in this app imports the default `axios` instance directly
// (no shared api client), so a global response interceptor registered once
// here is the only way to catch a 401 from ANY of those ~150+ call sites
// without touching each one. On a genuine auth failure, clears the stale
// session and bounces to login with a returnable path — mirrors RequireAuth's
// redirect so both paths land the admin back where they were after login.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const { pathname, search } = window.location;
      if (!isPublicAdminPath(pathname)) {
        localStorage.removeItem("token");
        localStorage.removeItem("username");
        localStorage.removeItem("password");
        localStorage.setItem("AdminCurrentUrl", `${pathname}${search}`);
        window.location.href = "/";
      }
    }
    return Promise.reject(error);
  }
);
